export default () => ({
  data: [],
  total: 0,
  page: 1,
  pages: 0
})
